export default "__VITE_ASSET__DOZhaPPF__"